// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"e780b37a","665":"a563be42","758":"5de553b4","919":"4baa5d3b","937":"9ac33dfc"}[chunkId] + ".chunk.css";
};